/**
 * @generated SignedSource<<b0df0b95d0f31cbea1d25d9d64ecff7e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleContent_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleCarousel_user">;
  readonly " $fragmentType": "HpSharedFeaturedModuleContent_user";
};
export type HpSharedFeaturedModuleContent_user$key = {
  readonly " $data"?: HpSharedFeaturedModuleContent_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleContent_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModuleContent_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedFeaturedModuleCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "0f8545f0c3ab1090b3c57655f65b064c";

export default node;
